(() => {
  const initHero = (root) => {
    if (!root || root.dataset.fvhReady === 'true') return;
    root.dataset.fvhReady = 'true';
    const fitDesktopHero = () => {
      if (!window.matchMedia('(min-width: 768px)').matches) return;
      const top = Math.max(0, root.getBoundingClientRect().top + window.scrollY);
      root.style.setProperty('--fvh-desktop-hero-height', Math.max(320, window.innerHeight - top) + 'px');
    };
    fitDesktopHero();
    window.addEventListener('resize', fitDesktopHero, { passive: true });
    window.addEventListener('load', fitDesktopHero, { once: true });

    const slides = [...root.querySelectorAll('[data-fvh-slide]')];
    const dots = [...root.querySelectorAll('[data-fvh-go]')];
    if (slides.length < 2) return;
    let index = 0;
    let timer = null;
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const autoplay = root.dataset.autoplay === 'true' && !reduceMotion;
    const speed = Number(root.dataset.speed) || 7000;

    const activate = (next) => {
      index = (next + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        const active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      dots.forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('is-active', active);
        if (active) dot.setAttribute('aria-current', 'true'); else dot.removeAttribute('aria-current');
      });
      const activeSlide = slides[index];
      root.classList.toggle('fvh-controls-on-dark', activeSlide.classList.contains('fvh-hero__slide--dark'));
      root.classList.toggle('fvh-controls-on-light', activeSlide.classList.contains('fvh-hero__slide--light'));
      slides.forEach((slide, i) => { slide.inert = i !== index; });
      const controls = root.querySelector('.fvh-hero__controls');
      const mobile = window.matchMedia('(max-width: 767px)').matches;
      if (controls) (mobile ? activeSlide.querySelector('[data-fvh-mobile-controls]') : root)?.appendChild(controls);
      root.querySelectorAll('[data-fvh-counter]').forEach(counter => { counter.textContent = `${index + 1} / ${slides.length}`; });
      const activeStyles = window.getComputedStyle(activeSlide);
      root.style.setProperty('--fvh-active-control-bg', activeStyles.getPropertyValue('--fvh-hero-control-bg').trim() || '#ffffff');
      root.style.setProperty('--fvh-active-control-text', activeStyles.getPropertyValue('--fvh-hero-control-text').trim() || '#111111');
      root.style.setProperty('--fvh-active-control-border', activeStyles.getPropertyValue('--fvh-hero-control-border').trim() || '#111111');
      restart();
    };

    const restart = () => {
      if (timer) window.clearTimeout(timer);
      if (autoplay) timer = window.setTimeout(() => activate(index + 1), speed);
    };

    dots.forEach((dot) => dot.addEventListener('click', () => activate(Number(dot.dataset.fvhGo))));
    root.querySelector('[data-fvh-prev]')?.addEventListener('click', () => activate(index - 1));
    root.querySelector('[data-fvh-next]')?.addEventListener('click', () => activate(index + 1));
    root.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowLeft') activate(index - 1);
      if (event.key === 'ArrowRight') activate(index + 1);
    });
    root.addEventListener('mouseenter', () => { if (timer) window.clearTimeout(timer); });
    root.addEventListener('mouseleave', restart);
    let startX = 0, startY = 0;
    root.addEventListener('touchstart', event => { startX = event.changedTouches[0].clientX; startY = event.changedTouches[0].clientY; }, { passive: true });
    root.addEventListener('touchend', event => {
      const dx = event.changedTouches[0].clientX - startX;
      const dy = event.changedTouches[0].clientY - startY;
      if (Math.abs(dx) > 60 && Math.abs(dx) > Math.abs(dy) * 1.5) activate(index + (dx < 0 ? 1 : -1));
    }, { passive: true });
    window.matchMedia('(max-width: 767px)').addEventListener('change', () => activate(index));
    activate(0);
  };

  const initAll = () => document.querySelectorAll('[data-fvh-hero]').forEach(initHero);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();

// Gallery-style quantity stepper. Keeps Shopify's native number input/form binding intact.
document.addEventListener('click', function (event) {
  var button = event.target.closest('[data-fvh-qty]');
  if (!button) return;
  var control = button.closest('.fvh-quantity__control');
  if (!control) return;
  var input = control.querySelector('input[type="number"]');
  if (!input || input.disabled) return;
  var min = Number(input.min || 1);
  var max = input.max ? Number(input.max) : Infinity;
  var value = Number(input.value || min);
  value += button.getAttribute('data-fvh-qty') === 'plus' ? 1 : -1;
  value = Math.max(min, Math.min(max, value));
  input.value = value;
  input.dispatchEvent(new Event('change', { bubbles: true }));
});

// R23: compact long collection descriptions without hiding short copy.
(() => {
  const initCollectionDescriptions = (scope = document) => {
    scope.querySelectorAll('[data-fvh-description]').forEach((root) => {
      if (root.dataset.fvhDescriptionReady === 'true') return;
      root.dataset.fvhDescriptionReady = 'true';
      const content = root.querySelector('[data-fvh-description-content]');
      const button = root.querySelector('[data-fvh-description-toggle]');
      const label = root.querySelector('[data-fvh-description-label]');
      if (!content || !button || !label) return;

      const update = () => {
        const wasExpanded = root.classList.contains('is-expanded');
        if (wasExpanded) root.classList.remove('is-expanded');
        const overflow = content.scrollHeight > content.clientHeight + 8;
        root.classList.toggle('is-collapsible', overflow);
        if (wasExpanded && overflow) root.classList.add('is-expanded');
      };

      button.addEventListener('click', () => {
        const expanded = root.classList.toggle('is-expanded');
        button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        label.textContent = expanded ? (button.dataset.readLess || 'Read less') : (button.dataset.readMore || 'Read more');
        const suffix = button.querySelector('[aria-hidden="true"]');
        if (suffix) suffix.textContent = expanded ? ' −' : ' +';
      });
      update();
      window.addEventListener('resize', update, { passive: true });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initCollectionDescriptions());
  } else {
    initCollectionDescriptions();
  }
  document.addEventListener('shopify:section:load', (event) => initCollectionDescriptions(event.target));
})();

/* ========================================================================
   R53 — Product detail blueprint polish
   Visual/DOM enhancement only. The Shopify product template, product JSON,
   native product form and native media gallery remain untouched.
   ======================================================================== */
(() => {
  const isProductPage = () => document.body.classList.contains('template-product') || !!document.querySelector('[data-section-type="product"]');

  let fvhProductI18nCache = null;
  const productI18n = () => {
    if (fvhProductI18nCache) return fvhProductI18nCache;
    const node = document.querySelector('[data-fvh-product-i18n]');
    if (!node) return {};
    try {
      fvhProductI18nCache = JSON.parse(node.textContent || '{}');
    } catch (error) {
      fvhProductI18nCache = {};
    }
    return fvhProductI18nCache;
  };
  const productText = (key, fallback) => productI18n()[key] || fallback;

  const iconSvg = (name) => {
    const common = 'viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"';
    const icons = {
      edition: `<svg ${common}><path d="M4 6.5 12 2l8 4.5-8 4.5-8-4.5Z"/><path d="m4 11 8 4.5 8-4.5"/><path d="m4 15.5 8 4.5 8-4.5"/></svg>`,
      technique: `<svg ${common}><path d="m4 20 5.5-1.5L20 8l-4-4L5.5 14.5 4 20Z"/><path d="m13.5 6.5 4 4"/></svg>`,
      dimensions: `<svg ${common}><path d="M4 9V4h5M15 4h5v5M20 15v5h-5M9 20H4v-5"/><path d="m4 4 6 6M20 4l-6 6M20 20l-6-6M4 20l6-6"/></svg>`,
      canvas: `<svg ${common}><rect x="4" y="4" width="16" height="16" rx="1"/><path d="M7 7h10v10H7z"/></svg>`,
      condition: `<svg ${common}><circle cx="12" cy="12" r="9"/><path d="m8.5 12 2.3 2.3L16 9"/></svg>`,
      signature: `<svg ${common}><path d="M3 16c2-5 3-7 4-7 1.5 0-.5 7 1.5 7 1.3 0 2.1-5 3.2-5 1.4 0-.1 4 1.8 4 1.7 0 2.8-3 4.5-3 1 0 1.7.7 3 2"/></svg>`,
      documentation: `<svg ${common}><path d="M6 3h8l4 4v14H6z"/><path d="M14 3v5h5M9 12h6M9 16h6"/></svg>`,
      framing: `<svg ${common}><rect x="4" y="4" width="16" height="16"/><path d="M7 7h10v10H7z"/></svg>`,
      shipping: `<svg ${common}><path d="M3 6h11v10H3zM14 9h4l3 3v4h-7z"/><circle cx="7" cy="18" r="2"/><circle cx="18" cy="18" r="2"/></svg>`,
      generic: `<svg ${common}><circle cx="12" cy="12" r="9"/><path d="M8 12h8"/></svg>`
    };
    return icons[name] || icons.generic;
  };

  const specIcon = (label) => {
    const key = String(label || '').toLowerCase();
    if (/(edition|auflage|édition|edizione|edición|editie|oplage|edição)/.test(key)) return 'edition';
    if (/(technique|technik|tecnica|técnica|techniek|medium)/.test(key)) return 'technique';
    if (/(dimension|size|maße|masse|misure|medidas|afmetingen|dimensões|tamanho)/.test(key)) return 'dimensions';
    if (/(thickness|dicke|épaisseur|spessore|grosor|dikte|espessura)/.test(key)) return 'edition';
    if (/(hang|aufhäng|accro|append|colgar|ophang|pendur)/.test(key)) return 'framing';
    if (/(canvas|leinwand|toile|tela|doek)/.test(key)) return 'canvas';
    if (/(condition|zustand|état|condizioni|estado|staat)/.test(key)) return 'condition';
    if (/(signature|signiert|signé|firmato|firmado|gesigneerd|assinado)/.test(key)) return 'signature';
    if (/(document|dokument|certificate|zertifikat|certificat|certificato|certificado)/.test(key)) return 'documentation';
    if (/(fram|rahm|cadre|cornice|marco|lijst|moldura)/.test(key)) return 'framing';
    if (/(ship|deliver|versand|liefer|expédition|livraison|spedizione|consegna|envío|entrega|verzending|levering|envio)/.test(key)) return 'shipping';
    return 'generic';
  };

  const enhanceProductInfo = (productRoot) => {
    const info = productRoot.querySelector('.item-info');
    if (!info || info.dataset.fvhPdpInfoReady === 'true') return;
    info.dataset.fvhPdpInfoReady = 'true';

    const titleBlock = info.querySelector('.type-title');
    const title = titleBlock?.querySelector('h1, h2, .fvh-heading-h2');
    if (titleBlock && title && !titleBlock.querySelector('.fvh-pdp-kicker')) {
      const kicker = document.createElement('div');
      kicker.className = 'fvh-pdp-kicker';
      kicker.textContent = productI18n().productKind === 'print' ? productText('readyToHangPrint', 'READY-TO-HANG PRINT') : productText('uniqueWork', 'UNIQUE WORK');
      titleBlock.insertBefore(kicker, title);
    }

    const shipping = info.querySelector('.shipping-policy');
    if (shipping && !shipping.querySelector('.fvh-shipping-icon')) {
      const icon = document.createElement('span');
      icon.className = 'fvh-shipping-icon';
      icon.innerHTML = iconSvg('shipping');
      shipping.prepend(icon);
    }

    const buyForm = info.querySelector('.type-buy_buttons form');
    const buttons = buyForm?.querySelector('.buttons');
    if (buyForm && buttons && !buttons.querySelector('.fvh-quantity__control')) {
      const qty = document.createElement('div');
      qty.className = 'fvh-quantity__control';
      const quantityLabel = productText('quantity', 'Quantity');
      qty.innerHTML = `
        <span class="visually-hidden"></span>
        <button type="button" class="fvh-quantity__button" data-fvh-qty="minus">−</button>
        <input class="fvh-quantity__input" type="number" name="quantity" value="1" min="1" inputmode="numeric">
        <button type="button" class="fvh-quantity__button" data-fvh-qty="plus">+</button>`;
      qty.querySelector('.visually-hidden').textContent = quantityLabel;
      qty.querySelector('[data-fvh-qty="minus"]').setAttribute('aria-label', productText('decreaseQuantity', 'Decrease quantity'));
      qty.querySelector('[data-fvh-qty="plus"]').setAttribute('aria-label', productText('increaseQuantity', 'Increase quantity'));
      qty.querySelector('input').setAttribute('aria-label', quantityLabel);
      buttons.insertBefore(qty, buttons.firstChild);
    }

    const share = info.querySelector('.type-share');
    if (share) share.classList.add('fvh-pdp-share');
  };

  const enhanceDescription = (productRoot) => {
    const description = productRoot.querySelector('.type-description .description.rte');
    if (!description || description.dataset.fvhSpecsReady === 'true') return;
    description.dataset.fvhSpecsReady = 'true';

    const firstParagraph = description.querySelector(':scope > p');
    if (firstParagraph) firstParagraph.classList.add('fvh-product-intro');

    const list = description.querySelector(':scope > ul, :scope > ol');
    if (!list) return;

    const details = document.createElement('details');
    details.className = 'fvh-product-specs';
    details.open = true;
    details.innerHTML = `<summary><span></span><span class="fvh-product-specs__chevron" aria-hidden="true">⌃</span></summary><div class="fvh-product-specs__rows"></div>`;
    details.querySelector('summary > span:first-child').textContent = productText('detailsSpecifications', 'DETAILS & SPECIFICATIONS');
    const rows = details.querySelector('.fvh-product-specs__rows');

    [...list.children].forEach((li) => {
      const raw = li.textContent.trim();
      const colon = raw.indexOf(':');
      const label = colon > -1 ? raw.slice(0, colon).trim() : productText('detail', 'Detail');
      const value = colon > -1 ? raw.slice(colon + 1).trim() : raw;
      const row = document.createElement('div');
      row.className = 'fvh-product-specs__row';
      row.innerHTML = `<span class="fvh-product-specs__icon">${iconSvg(specIcon(label))}</span><span class="fvh-product-specs__label"></span><span class="fvh-product-specs__value"></span>`;
      row.querySelector('.fvh-product-specs__label').textContent = label;
      row.querySelector('.fvh-product-specs__value').textContent = value;
      rows.appendChild(row);
    });

    const note = [...description.querySelectorAll(':scope > p')].find((p) => /^\s*\*/.test(p.textContent));
    let noteEl = null;
    if (note) {
      noteEl = document.createElement('p');
      noteEl.className = 'fvh-product-specs__note';
      noteEl.innerHTML = note.innerHTML;
      note.remove();
    }
    list.remove();
    description.insertAdjacentElement('afterend', details);
    if (noteEl) details.insertAdjacentElement('afterend', noteEl);

    details.addEventListener('toggle', () => {
      const chevron = details.querySelector('.fvh-product-specs__chevron');
      if (chevron) chevron.textContent = details.open ? '⌃' : '⌄';
    });
  };

  const enhanceGallery = (productRoot) => {
    const media = productRoot.querySelector('.item-media');
    if (!media || media.dataset.fvhGalleryReady === 'true') return;
    media.dataset.fvhGalleryReady = 'true';
    media.classList.add('fvh-pdp-gallery');

    const gallery = media.querySelector('.gallery');
    const frame = media.querySelector('.frame');
    const thumbs = gallery?.querySelector('.thumbs');
    if (!gallery || !frame || !thumbs) return;

    gallery.querySelector('[data-action="previous-product-media"]')?.setAttribute('aria-label', productText('previousThumbnail', 'Previous thumbnail'));
    gallery.querySelector('[data-action="next-product-media"]')?.setAttribute('aria-label', productText('nextThumbnail', 'Next thumbnail'));

    const keepActiveThumbVisible = () => {
      const active = thumbs.querySelector('.thumb.active');
      if (!active || !window.matchMedia('(max-width: 767px)').matches || thumbs.scrollWidth <= thumbs.clientWidth) return;
      const rail = thumbs.getBoundingClientRect();
      const item = active.getBoundingClientRect();
      const offset = item.left < rail.left ? item.left - rail.left : item.right > rail.right ? item.right - rail.right : 0;
      if (offset) thumbs.scrollBy({ left: offset, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    };

    const observer = new MutationObserver((mutations) => {
      if (mutations.some((m) => m.type === 'attributes' && m.attributeName === 'class')) keepActiveThumbVisible();
    });
    thumbs.querySelectorAll('.thumb').forEach((thumb) => observer.observe(thumb, { attributes: true }));
    keepActiveThumbVisible();
  };

  const enhanceRelated = () => {
    const wrapper = document.querySelector('.product-recommendations .product-related-products');
    if (!wrapper || wrapper.dataset.fvhRelatedReady === 'true') return;
    wrapper.dataset.fvhRelatedReady = 'true';
    const heading = wrapper.querySelector(':scope > :is(h2,.fvh-heading-h2)');
    const row = wrapper.querySelector(':scope > .row');
    if (!heading || !row) return;

    const head = document.createElement('div');
    head.className = 'fvh-related-head';
    const titleWrap = document.createElement('div');
    titleWrap.innerHTML = '<p class="fvh-pdp-eyebrow"></p>';
    titleWrap.querySelector('.fvh-pdp-eyebrow').textContent = productText('relatedArtworks', 'RELATED ARTWORKS');
    heading.classList.add('fvh-related-title');
    titleWrap.appendChild(heading);
    const link = document.createElement('a');
    link.className = 'fvh-related-view-all';
    link.href = productI18n().allArtworksUrl || '/collections/all';
    link.textContent = `${productText('viewAllArtworks', 'View all artworks')}  →`;
    head.append(titleWrap, link);
    wrapper.insertBefore(head, row);
  };

  const enhanceFaq = () => {
    const faq = document.querySelector('.section-faq .faq, .faq[data-section-type="faq"]');
    if (!faq || faq.dataset.fvhPdpFaqReady === 'true') return;
    faq.dataset.fvhPdpFaqReady = 'true';
    let titles = faq.querySelector('.titles');
    if (!titles) {
      titles = document.createElement('div');
      titles.className = 'titles';
      faq.querySelector('.inner')?.prepend(titles);
    }
    if (!titles.querySelector('.fvh-pdp-eyebrow')) {
      const eyebrow = document.createElement('p');
      eyebrow.className = 'fvh-pdp-eyebrow';
      eyebrow.textContent = productText('faqEyebrow', 'FAQ');
      titles.prepend(eyebrow);
    }
    const title = titles.querySelector('.section-title');
    if (title) title.textContent = productText('faqHeading', 'You might also like to know');
  };

  const initProductBlueprint = () => {
    if (!isProductPage()) return;
    const productRoot = document.querySelector('[data-section-type="product"]');
    if (!productRoot) return;
    enhanceProductInfo(productRoot);
    enhanceDescription(productRoot);
    enhanceGallery(productRoot);
    enhanceRelated();
    enhanceFaq();
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initProductBlueprint);
  else initProductBlueprint();
  document.addEventListener('shopify:section:load', initProductBlueprint);
  window.setTimeout(initProductBlueprint, 700);
  window.setTimeout(enhanceRelated, 1400);
})();

/* ========================================================================
   R54 — Premium storefront selects
   Replaces the browser-native open menu for collection sorting while keeping
   the original <select> as the form/source of truth.
   ======================================================================== */
(() => {
  const SELECTOR = '.fvh-collection-sort-form select, .fvh-mobile-sort select';

  const close = (wrapper, focusButton = false) => {
    if (!wrapper) return;
    const button = wrapper.querySelector('.fvh-premium-select__button');
    const menu = wrapper.querySelector('.fvh-premium-select__menu');
    wrapper.classList.remove('is-open');
    button?.setAttribute('aria-expanded', 'false');
    if (menu) menu.hidden = true;
    if (focusButton) button?.focus();
  };

  const closeAll = (except = null) => {
    document.querySelectorAll('.fvh-premium-select.is-open').forEach((wrapper) => {
      if (wrapper !== except) close(wrapper);
    });
  };

  const enhance = (select) => {
    if (!select || select.dataset.fvhPremiumReady === 'true') return;
    select.dataset.fvhPremiumReady = 'true';

    const wrapper = document.createElement('div');
    wrapper.className = 'fvh-premium-select';
    select.parentNode.insertBefore(wrapper, select);
    wrapper.appendChild(select);
    select.classList.add('fvh-premium-select__native');

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'fvh-premium-select__button';
    button.setAttribute('aria-haspopup', 'listbox');
    button.setAttribute('aria-expanded', 'false');
    button.innerHTML = '<span class="fvh-premium-select__value"></span><span class="fvh-premium-select__chevron" aria-hidden="true"></span>';

    const menu = document.createElement('div');
    menu.className = 'fvh-premium-select__menu';
    menu.setAttribute('role', 'listbox');
    menu.hidden = true;

    const update = () => {
      const selected = select.options[select.selectedIndex];
      const value = button.querySelector('.fvh-premium-select__value');
      if (value) value.textContent = selected ? selected.textContent : '';
      menu.querySelectorAll('.fvh-premium-select__option').forEach((optionButton) => {
        optionButton.setAttribute('aria-selected', optionButton.dataset.value === select.value ? 'true' : 'false');
      });
    };

    [...select.options].forEach((option) => {
      const optionButton = document.createElement('button');
      optionButton.type = 'button';
      optionButton.className = 'fvh-premium-select__option';
      optionButton.setAttribute('role', 'option');
      optionButton.dataset.value = option.value;
      optionButton.textContent = option.textContent;
      optionButton.addEventListener('click', () => {
        if (select.value !== option.value) {
          select.value = option.value;
          select.dispatchEvent(new Event('input', { bubbles: true }));
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
        update();
        close(wrapper, true);
      });
      menu.appendChild(optionButton);
    });

    const open = () => {
      closeAll(wrapper);
      wrapper.classList.add('is-open');
      button.setAttribute('aria-expanded', 'true');
      menu.hidden = false;
      const selected = menu.querySelector('[aria-selected="true"]') || menu.querySelector('.fvh-premium-select__option');
      window.requestAnimationFrame(() => selected?.focus());
    };

    button.addEventListener('click', () => {
      if (wrapper.classList.contains('is-open')) close(wrapper);
      else open();
    });
    button.addEventListener('keydown', (event) => {
      if (['ArrowDown', 'Enter', ' '].includes(event.key)) {
        event.preventDefault();
        open();
      }
    });
    menu.addEventListener('keydown', (event) => {
      const options = [...menu.querySelectorAll('.fvh-premium-select__option')];
      const current = options.indexOf(document.activeElement);
      if (event.key === 'ArrowDown') {
        event.preventDefault();
        options[(current + 1 + options.length) % options.length]?.focus();
      } else if (event.key === 'ArrowUp') {
        event.preventDefault();
        options[(current - 1 + options.length) % options.length]?.focus();
      } else if (event.key === 'Escape') {
        event.preventDefault();
        close(wrapper, true);
      }
    });
    select.addEventListener('change', update);

    wrapper.append(button, menu);
    update();
  };

  const init = (scope = document) => scope.querySelectorAll(SELECTOR).forEach(enhance);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
  document.addEventListener('click', (event) => {
    if (!event.target.closest('.fvh-premium-select')) closeAll();
  });
})();

/* ========================================================================
   FVH reusable collector carousel
   ======================================================================== */
(() => {
  const initCollectorCarousel = (carousel) => {
    if (!carousel || carousel.dataset.fvhCollectorReady === 'true') return;
    carousel.dataset.fvhCollectorReady = 'true';

    const track = carousel.querySelector('.fvh-collector-carousel__track');
    const cards = Array.from(carousel.querySelectorAll('.fvh-review-card'));
    const prevButton = carousel.querySelector('.fvh-collector-carousel__prev');
    const nextButton = carousel.querySelector('.fvh-collector-carousel__next');
    const dotsContainer = carousel.querySelector('.fvh-collector-carousel__dots');
    if (!track || !cards.length || !prevButton || !nextButton || !dotsContainer) return;

    let currentIndex = 0;
    let autoplayTimer = null;
    let resizeTimer = null;

    const visibleCards = () => {
      if (window.innerWidth <= 650) return 1;
      if (window.innerWidth <= 990) return 2;
      return 3;
    };

    const maximumIndex = () => Math.max(0, cards.length - visibleCards());

    const cardStep = () => {
      if (cards.length < 2) return 0;
      const firstCard = cards[0].getBoundingClientRect();
      const secondCard = cards[1].getBoundingClientRect();
      return secondCard.left - firstCard.left;
    };

    const updateCarousel = () => {
      const max = maximumIndex();
      currentIndex = Math.min(Math.max(currentIndex, 0), max);
      track.style.transform = `translateX(-${currentIndex * cardStep()}px)`;
      dotsContainer.querySelectorAll('.fvh-collector-carousel__dot').forEach((dot, index) => {
        dot.classList.toggle('is-active', index === currentIndex);
        if (index === currentIndex) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };

    const createDots = () => {
      dotsContainer.innerHTML = '';
      const totalPositions = maximumIndex() + 1;
      const dotLabel = carousel.dataset.dotLabel || 'Show review set';
      for (let i = 0; i < totalPositions; i += 1) {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'fvh-collector-carousel__dot';
        dot.setAttribute('aria-label', `${dotLabel} ${i + 1}`);
        dot.addEventListener('click', () => {
          currentIndex = i;
          updateCarousel();
          restartAutoplay();
        });
        dotsContainer.appendChild(dot);
      }
    };

    const nextSlide = () => {
      const max = maximumIndex();
      currentIndex = currentIndex >= max ? 0 : currentIndex + 1;
      updateCarousel();
    };

    const previousSlide = () => {
      const max = maximumIndex();
      currentIndex = currentIndex <= 0 ? max : currentIndex - 1;
      updateCarousel();
    };

    const startAutoplay = () => {
      window.clearInterval(autoplayTimer);
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      autoplayTimer = window.setInterval(nextSlide, 7000);
    };
    const restartAutoplay = () => startAutoplay();

    prevButton.addEventListener('click', () => {
      previousSlide();
      restartAutoplay();
    });
    nextButton.addEventListener('click', () => {
      nextSlide();
      restartAutoplay();
    });

    window.addEventListener('resize', () => {
      window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(() => {
        createDots();
        updateCarousel();
      }, 120);
    }, { passive: true });

    carousel.addEventListener('mouseenter', () => window.clearInterval(autoplayTimer));
    carousel.addEventListener('mouseleave', startAutoplay);

    createDots();
    updateCarousel();
    startAutoplay();
  };

  const initCollectorCarousels = (scope = document) => {
    if (scope.matches?.('[data-fvh-collector-carousel]')) initCollectorCarousel(scope);
    scope.querySelectorAll?.('[data-fvh-collector-carousel]').forEach(initCollectorCarousel);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initCollectorCarousels());
  } else {
    initCollectorCarousels();
  }
  document.addEventListener('shopify:section:load', (event) => initCollectorCarousels(event.target));
})();
